import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../../util/utill'
import { APIEndPoints } from '../../APIEndPoints'
import { sitConfig } from '../../config'
import { sendEventApi } from '../../sendEvent'
const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw { message: 'OTP verification service is temporarily down (500).', code: 'SERVER_ERROR' };
  }
  if (isStatusOK(data)) {
    return data?.data
  } else if (data?.data?.error?.code === '33872' && data?.data?.authorizationCode) {
    // console.log('NETWORK PARSER: Handled 33872 success case.')
    return data?.data
  } else {
    console.error('NETWORK PARSER: Throwing true failure:', data?.data)
    const errorInput = data?.data || data || { message: 'OTP Verification Failed' };
    throw getNetworkResponseError(errorInput)
    // throw getNetworkResponseError(data?.data)
  }
}
export const VerifyOtpBCApi = (
  tokens: any,
  body: { mobileNumber: string; encryptedOtp: string; encryptedSymmetricKey: string },
) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const requestBody = {
    user: {
      mobile: {
        mobileNumber: body?.mobileNumber,
        countryCode: '91',
      },
      entityType: 4,
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: 50,
        value: body.encryptedOtp,
        action: 'verify',
      },
    ],
    purpose: 5,
    secure: {
      encryptionKey: body.encryptedSymmetricKey,
    },
    extraInfo: RootStore?.agent?.session?.CHANNEL_ID || '',
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.verifyOtpUser,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to respponse parse')
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
